import React from 'react'
import TimelineIcon from '@mui/icons-material/Timeline';
import TranslateIcon from '@mui/icons-material/Translate';
import QuestionAnswerIcon from '@mui/icons-material/QuestionAnswer';
import PolicyIcon from '@mui/icons-material/Policy';
import AccessibilityIcon from '@mui/icons-material/Accessibility';
import GroupAddIcon from '@mui/icons-material/GroupAdd';
import PostAddIcon from '@mui/icons-material/PostAdd';
import CategoryIcon from '@mui/icons-material/Category';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import FilterListIcon from '@mui/icons-material/FilterList';
import PaletteIcon from '@mui/icons-material/Palette';
import CalendarViewDayIcon from '@mui/icons-material/CalendarViewDay';
import FeaturedPlayListIcon from '@mui/icons-material/FeaturedPlayList';
import SettingsIcon from '@mui/icons-material/Settings';
import WebAssetIcon from '@mui/icons-material/WebAsset';
import AcUnitIcon from '@mui/icons-material/AcUnit';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import RateReviewIcon from '@mui/icons-material/RateReview';
import StarHalfIcon from '@mui/icons-material/StarHalf';

/**
 * @description all sidebar items list
 * Add your sidebar item here in this list
 * @author jagannath
 * @date 09/04/2021
 * @param color String - icon color
 * @return Array of sidebar items 
 */
const sidebarList = (color) => {
    return [
        {
            title: 'Dashboard',
            icon: <TimelineIcon style={{color}} />,
            home: true,
            path: '/dashboard'
        },
        {
            title: 'Language',
            icon: <TranslateIcon style={{color}} />,
            home: true,
            path: '/language'
        },
        {
            title: 'Users',
            icon: <GroupAddIcon style={{color}} />,
            home: true,
            path: '/users'
        },
        {
            title: 'Products',
            icon: <PostAddIcon style={{color}} />,
            home: true,
            path: '/products'
        },
        {
            title: 'Categories',
            icon: <CategoryIcon style={{color}} />,
            home: true,
            path: '/categories'
        },
        {
            title: 'Attributes',
            icon: <AccountTreeIcon style={{color}} />,
            home: true,
            path: '/attributes'
        },
        
        {
            title: "Reviews & Ratings",
            icon: <StarBorderIcon style={{color}} />,
            home: false,
            children: [
                {
                    title: "Reviews & Ratings",
                    icon: <StarHalfIcon style={{color}} />,
                    path: "/review-and-ratings"
                },
                {
                    title: "Review Parameters",
                    icon: <RateReviewIcon style={{color}} />,
                    path: '/review-parameters'
                }
            ]
        },
        {
            title: 'SEO',
            icon: <AcUnitIcon style={{color}} />,
            home: true,
            path: '/seo-settings'
        },
        {
            title: 'App Settings',
            icon: <SettingsIcon style={{color}} />,
            home: true,
            path: '/app-settings'
        },
        {
            title: 'App Assets',
            icon: <WebAssetIcon style={{color}} />,
            home: true,
            path: '/app-assets'
        },
        {
            title: 'Filters',
            icon: <FilterListIcon style={{color}} />,
            home: true,
            path: '/filters'
        },
        {
            title: 'Colors',
            icon: <PaletteIcon style={{color}} />,
            home: true,
            path: '/colors'
        },
        {
            title: 'Brands',
            icon: <CalendarViewDayIcon style={{color}} />,
            home: true,
            path: '/brands'
        },
        {
            title: 'Models',
            icon: <FeaturedPlayListIcon style={{color}} />,
            home: true,
            path: '/models'
        },
        {
            title: 'Terms & Conditions',
            icon: <AccessibilityIcon style={{color}} />,
            home: true,
            path: '/terms-and-conditions'
        },
        {
            title: 'Privacy Policy',
            icon: <PolicyIcon style={{color}} />,
            home: true,
            path: '/privacy-policy'
        },
        {
            title: 'FAQ',
            icon: <QuestionAnswerIcon style={{color}} />,
            home: true,
            path: '/faq'
        },
    ]
}

export default sidebarList
